import React, { useContext, useState } from 'react'
import { firestore } from '../../firebase';
import StateContext from '../../StateContext';
import AddFollowToUserCollection from './Templates/AddFollowToUserCollection';

function AddFollow({userId, userObj, isFollowing, setIsFollowing}) {

    const appState = useContext(StateContext)
    const [message, setMessage] = useState("")
    const [isLoading, setIsLoading] = useState(false);

    

    const [add, setAdd] = useState(false)

    // Add followed user to logged in users collection
    async function addFollowToUserDoc() {
        if (userId && userObj && appState.userData.authorId) {

            console.log(userId, "userId", userObj)

            console.log("AuthorID: ", appState.userData.authorId)

            console.log("Trying to add follow to your collection")
            try {
                const userRef = firestore.collection("authors").doc(appState.userData.authorId).collection("following")
                const data = {
                    author_data: userObj,
                    author_id: userId
                }
                userRef.add(data)
                console.log("ADDED")
            } catch (error) {
                console.log(error, "Error adding user to author collection following")
                
            }
        }
    }

    async function addFollowHandler(e) {
        e.preventDefault();
        setIsLoading(true)
        if (isFollowing) {
            setMessage("Kan ikke følge en person du følger fra før")
            return 
        }

        if (appState.userData && appState.userData.name) {
            console.log(appState.userData)

            try {
                addFollowToUserDoc()
                const followRef = firestore.collection("follow");
    
                const data = {
                    follower_profile_image: appState.userData.profile_image,
                    follower_name: appState.userData.name,
                    follower_id: appState.userId,

                    followed_name: userObj.name,
                    followed_profile_image: userObj.profile_image,
                    followed_id: userId
                }
    
                const following = await followRef.add(data)
                setAdd(true)
                setMessage("Følger!")
                setIsFollowing(true)
            } catch (error) {
                console.log(error)
                setMessage("Noe gikk galt")
            }
        }
        setIsLoading(false)

    }


    return (
        <form onSubmit={addFollowHandler}>
            {message && <div>{message}</div>}
            <button 
                disabled={isLoading} 
                className="follow-button bg-primary text-white"
            >
                Følg <AddFollowToUserCollection authorObject={userObj} author_id={appState.userId} add={add} />
            </button>
        </form>
    )

}
export default AddFollow